import TiptapEditorContextProvider from "@src/components/libraryItemDetailPages/course/contexts/TiptapEditorContext";
import { FC } from "react";
import RichTextEditor from "../course/RichTextEditor";

type RichTextProps = {
  text: string;
};

const ReadOnlyTrainingRichTextDocument: FC<RichTextProps> = ({ text }) => {
  return (
    <TiptapEditorContextProvider tiptapEditorId={`rich-text-read-only-${text}`}>
      <RichTextEditor
        key={`rich-text-read-only-${text}`}
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className="rich-text-opus-doc-editor"
        text={text || ""}
        disableTextVariants
        onChange={() => {}}
        hasEditContentPermission={false}
        enableMathematics={true}
      />
    </TiptapEditorContextProvider>
  );
};

export default ReadOnlyTrainingRichTextDocument;
